import React from "react";
import { Grid, Skeleton, Chip } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useHistory } from "react-router-dom";
import RoutesName from "routes/routesName";
type Cat = {
    id: number;
    name: string;
    slug: string;
    totalSceneCount: number;
};

type Props = {
    category?: Cat;
};

const CategoryCard: React.FC<Props> = ({ category }) => {
    const router = useHistory();

    const handleLoad = (): void => {
        if (!category) return;
        router.push({
            pathname: RoutesName.category.replace(":slug*", category.slug),
        });
    };

    return (
        <Grid item xs={12} sm={6} md={3}>
            {!category ? (
                <Card className="presetCard">
                    <Skeleton variant="rectangular" className="presetCard" />
                    <CardContent className="cardContent">
                        <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: "6px 0" }}
                        >
                            <Grid item xs={8}>
                                <React.Fragment>
                                    <Skeleton
                                        animation="wave"
                                        height={20}
                                        style={{ marginRight: 10, width: "60%" }}
                                    />
                                </React.Fragment>
                            </Grid>
                            <Grid item xs={4}>
                                <div
                                    style={{
                                        flexDirection: "row",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <Skeleton
                                        animation="wave"
                                        variant="circular"
                                        sx={{ width: 40, height: 40 }}
                                    />
                                    <Skeleton
                                        animation="wave"
                                        height={20}
                                        style={{ marginLeft: 20, width: 40 }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            ) : (
                <Card className="categoryCard" onClick={handleLoad}>
                    <CardContent className="cardContent">
                        <div>{category.name}</div>
                        <Chip label={category.totalSceneCount} color="primary" />
                    </CardContent>
                </Card>
            )}
        </Grid>
    );
};

export default CategoryCard;
